import { debounce } from '../functions.js';

export default function FluidImageModule(element) {

    let EffectComposer = window.THREEImports.EffectComposer;
    let RenderPass     = window.THREEImports.RenderPass;
    let ShaderPass     = window.THREEImports.ShaderPass;
    let GlitchPass     = window.THREEImports.GlitchPass;

    let originalImage = element.querySelector('img');

    if (!originalImage) {
        console.warn('No image found in FluidImageModule');
        return;
    }

    let imageSrc = originalImage.src;
    let container = element;

    var camera, scene, renderer, composer, renderPass, customPass;
    var geometry, material, mesh, texture, uMouse = new THREE.Vector2(0,0);

    let dummyimg = document.createElement('img');
    dummyimg.onload = function(){
        texture = new THREE.Texture(this);
        texture.needsUpdate = true;
        init()
        animate();
    }
    dummyimg.src = imageSrc;


    function init() {

        camera = new THREE.PerspectiveCamera(50, container.clientWidth / container.clientHeight, 0.01, 10 );
        camera.position.z = 0.32;

        scene = new THREE.Scene();

        geometry = new THREE.PlaneGeometry(0.45, 0.3);
        
        material = new THREE.MeshBasicMaterial({
            map: texture
        });

        mesh = new THREE.Mesh(geometry, material);
        scene.add(mesh);
        scene.background = null;
        // scene.background = new THREE.Color('#FFFF00')

        renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });

        renderer.setSize(container.clientWidth, container.clientHeight);
        renderer.outputEncoding = THREE.sRGBEncoding;

        container.appendChild(renderer.domElement);

        // post processing
        composer = new EffectComposer(renderer);

        renderPass = new RenderPass(scene, camera);
        composer.addPass(renderPass);

        var myEffect = {
            uniforms: {
                'tDiffuse':     { value: null },
                'resolution':   { value: new THREE.Vector2(1, container.clientHeight/container.clientWidth) },
                'uMouse':       { value: new THREE.Vector2(-10,-10) },
                'uVelo':        { value: 0 },
            },
            vertexShader: `varying vec2 vUv;
                void main() {
                    vUv = uv;
                    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }`,
            fragmentShader: `
            
            uniform float time;
            uniform sampler2D tDiffuse;
            uniform vec2 resolution;
            varying vec2 vUv;
            uniform vec2 uMouse;

            float circle(vec2 uv, vec2 disc_center, float disc_radius, float border_size) {
                uv -= disc_center;
                uv *= resolution;
                float dist = sqrt(dot(uv, uv));
                return smoothstep(disc_radius+border_size, disc_radius-border_size, dist);
            }

            void main()  {

                vec2 newUV = vUv;
                float c = circle(vUv, uMouse, 0.0, 0.4);
                float r = texture2D(tDiffuse, newUV.xy += c * (0.1 * .5)).x;
                float g = texture2D(tDiffuse, newUV.xy += c * (0.1 * .525)).y;
                float b = texture2D(tDiffuse, newUV.xy += c * (0.1 * .55)).z;
                vec4 color = vec4(r, g, b, 1);
                
                gl_FragColor = color;

            }`
        }

        customPass = new ShaderPass(myEffect);
        customPass.renderToScreen = true;
        composer.addPass(customPass);

        let glitchPass = new GlitchPass();
        composer.addPass( glitchPass );

    }

    container.addEventListener('mousemove', (e) => {
        uMouse.x = (e.offsetX / container.clientWidth ) ;
        uMouse.y = 1 - ( e.offsetY / container.clientHeight );
    });

    function animate() {
        customPass.uniforms.uMouse.value = uMouse;
        requestAnimationFrame(animate);
        composer.render()
    }


    window.addEventListener('resize', debounce (function() {
        if (renderer) {
            renderer.setSize(container.clientWidth, container.clientHeight);
        }
    }, 100));
    
}
